/* BOXO – kolleksjonssider:
   1) sortering bytter produkter på stedet (Ajax) i stedet for å laste siden på nytt
   2) siden står i ro ved filter/sortering */
(function () {
  if (!window.theme || !theme.Collection || !theme.Collection.prototype) return;

  // Ingen rulling etter filter/sortering
  theme.Collection.prototype.updateScroll = function () {};

  // Sortering via Ajax (gjelder alle nye instanser, f.eks. etter filtrering)
  theme.Collection.prototype.onSortChange = function () {
    var params = new URLSearchParams(window.location.search);
    params.delete('sort_by');
    params.delete('page');
    // Fjern gammel sortering fra adressen, ellers legger temaet den nye bak den gamle
    var rest = params.toString();
    history.replaceState(history.state, '', window.location.pathname + (rest ? '?' + rest : ''));
    params.set('sort_by', this.getSortValue());
    this.startLoading();
    this.renderCollectionPage(params);
  };

  // Den første instansen er allerede koblet til gammel funksjon – koble om feltet
  function kobleOm() {
    var sel = document.getElementById('SortBy');
    if (!sel || sel.dataset.boxoBound) return;
    var instans = (theme.sections && theme.sections.instances || []).find(function (i) {
      return i.type === 'collection-grid' && i.context !== 'featured-collection';
    });
    if (!instans) return;
    var ny = sel.cloneNode(true);          // klon = fjerner temaets gamle lytter
    sel.parentNode.replaceChild(ny, sel);
    ny.dataset.boxoBound = '1';
    instans.sortSelect = ny;
    ny.addEventListener('change', function () { instans.onSortChange(); });
  }

  kobleOm();
  document.addEventListener('collection:reloaded', kobleOm);
})();

/* BOXO – filteret: står åpent på mobil, tar med alle klikk, viser valg med 0 treff */
(function () {
  if (!window.theme || !theme.Collection) return;
  var html = document.documentElement;
  var holdApenTil = 0, scrollPos = 0, patchet = false;
  var laster = false, onske = null, sendt = '', timer = null, nodstopp = null, gammel = null;

  var css = document.createElement('style');
  css.textContent =
    // Ingen inntoning/blinking mens filteret står åpent og produktene lastes
    'html.boxo-filter-stille #FilterDrawer .appear-animation{animation:none!important;transition:none!important;opacity:1!important;transform:none!important}' +
    'html.boxo-filter-stille #FilterDrawer,html.boxo-filter-stille .collection-hero__image,html.boxo-filter-stille .section-header,html.boxo-filter-stille .main-content::after{animation:none!important;transition:none!important}' +
    // Valg med 0 treff vises (grå og ikke klikkbare) i stedet for å forsvinne
    '.tag-list .tag.hide{display:list-item!important}' +
    '.tag-list .tag.hide:not(.tag--active){opacity:.4;pointer-events:none}';
  document.head.appendChild(css);

  // Temaet bruker samme ID-er i desktop- og mobilfilteret – gi mobilfilteret egne
  function egneId() {
    document.querySelectorAll('#FilterDrawer label.tag__checkbox-wrapper[for]').forEach(function (l) {
      var i = l.querySelector('input');
      if (!i || i.id.indexOf('SidebarDrawer-') === 0) return;
      i.id = 'SidebarDrawer-' + i.id;
      l.htmlFor = i.id;
    });
  }
  egneId();
  document.addEventListener('DOMContentLoaded', egneId);

  function instans() {
    var liste = (theme.sections && theme.sections.instances || []).filter(function (i) {
      return i.type === 'collection-grid' && i.context !== 'featured-collection';
    });
    return liste[liste.length - 1];
  }

  // Temaet lukker filteret flere ganger mens det laster – hopp over det
  function patch() {
    if (patchet || !theme.FilterDrawer) return;
    var proto = Object.getPrototypeOf(theme.FilterDrawer), lukk = proto.close;
    proto.close = function () {
      if (Date.now() < holdApenTil && this.drawer && this.drawer.id === 'FilterDrawer') return;
      return lukk.apply(this, arguments);
    };
    patchet = true;
  }

  function holdApen() {
    var d = document.getElementById('FilterDrawer');
    if (!d || !d.classList.contains('drawer--is-open')) return;
    patch();
    gammel = theme.FilterDrawer;
    var s = d.querySelector('.drawer__scrollable');
    scrollPos = s ? s.scrollTop : 0;
    holdApenTil = Date.now() + 10000;
    html.classList.add('boxo-filter-stille');
  }

  function ferdig() {
    laster = false;
    clearTimeout(nodstopp);
    document.querySelectorAll('.unload').forEach(function (el) { el.classList.remove('unload'); });
  }

  function send(params) {
    var inst = instans();
    if (!inst) return;
    laster = true;
    sendt = params.toString();
    clearTimeout(nodstopp);
    nodstopp = setTimeout(ferdig, 10000); // nødstopp hvis noe henger
    inst.startLoading();
    inst.renderCollectionPage(params);
  }

  // Vi tar over filterklikkene: siste valg huskes med en gang, raske klikk samles,
  // og det lastes bare én gang om gangen
  document.addEventListener('input', function (e) {
    var form = e.target.closest && e.target.closest('form.filter-form');
    if (!form) return;
    e.stopImmediatePropagation();
    if (document.getElementById('FilterDrawer') && document.getElementById('FilterDrawer').contains(form)) holdApen();
    onske = new URLSearchParams(new FormData(form));
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!laster && onske) send(onske);
    }, 250);
  }, true);

  // Kryss på aktive valg (mørkeblå merker)
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.tag--remove')) return;
    var d = document.getElementById('FilterDrawer');
    if (d && d.contains(e.target)) holdApen();
    onske = null;
    laster = true;
    clearTimeout(nodstopp);
    nodstopp = setTimeout(ferdig, 10000);
  }, true);

  // Produktene er lastet
  document.addEventListener('collection:reloaded', function () {
    egneId();
    ferdig();
    // Har kunden klikket mer mens det lastet? Vis valgene med en gang og last på nytt
    var neste = (onske && onske.toString() !== sendt) ? onske : null;
    if (neste) {
      document.querySelectorAll('form.filter-form input[type="checkbox"]').forEach(function (i) {
        i.checked = neste.getAll(i.name).indexOf(i.value) > -1;
      });
    } else {
      onske = null;
    }
    // Rydd bort den gamle utgaven av filteret, ellers stopper den trykk utenfor/X
    if (gammel && gammel !== theme.FilterDrawer) {
      gammel.isOpen = false;
      try { gammel.unbindEvents(); } catch (err) {}
    }
    gammel = null;
    var d = document.getElementById('FilterDrawer');
    if (Date.now() < holdApenTil && d && theme.FilterDrawer) {
      gammel = theme.FilterDrawer;
      theme.FilterDrawer.open();
      var s = d.querySelector('.drawer__scrollable');
      if (s) s.scrollTop = scrollPos;
    }
    if (neste) { send(neste); return; }
    holdApenTil = 0;
    setTimeout(function () { html.classList.remove('boxo-filter-stille'); }, 400);
  });
})();